import { render, staticRenderFns } from "./BrutCreateOrUpdate.vue?vue&type=template&id=5ce37b80&"
import script from "./BrutCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BrutCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports